import { render, staticRenderFns } from "./RejectReason.vue?vue&type=template&id=5a4f1f09"
import script from "./RejectReason.vue?vue&type=script&lang=js"
export * from "./RejectReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports